<app-toast-message [justAfterLogin]="justAfterLogin"></app-toast-message>
<header id="topNav">
  <ng-container>
    <app-nav-bar #navBarRef [currentItem]="selectedLeftMenu" (showNavEvent)="updateShowNav($event)">
    </app-nav-bar>
  </ng-container>

  <div class="row mx-0 authoring-header justify-content-end"
    [ngClass]="[showNav?'':'expend-row', (showPGHClass===true?'pacing-guide-authoring-header bg-white':''), (customView?'m-0':''), (!projectAuthoringView?'pt-4':'')]">
    <div class="col-2" [ngClass]="showBack?'d-none':''"></div>
    <div class="col left-panel"
      [ngClass]="[showNav?'project-authoring-bg':'', customView || removeBG?'bg-white':'', (showPGHClass===true?'bg-white':'')]"
      [class.search-wrapper]="searchText.length>2" [hidden]="searchTrigger">

      <div class="row align-items-center justify-content-start">
        <div class="col-md-1 col-xl-auto p-0 pl-2" *ngIf="showBack">
          <button type="button" (click)="onBack()" [attr.aria-label]="'Go Back'"
            class="btn btn-icon d-flex align-items-center tooltip bottom sm bottom-left position-relative ml-1 pl-2"
            id="backtoprojBtn" data-tooltip="Back">
            <em class="ic-flip custom-ic-flip align-text-top material-icons-outlined text-blue" aria-hidden="true">arrow_forward_ios</em>
          </button>
        </div>

        <div [ngClass]="showBack?'col-11 p-0':'col-12 px-0'" class="d-flex align-items-center">
          <div class="col d-flex align-items-center justify-content-center"
            [ngClass]="[(!textLeft ? 'text-center' : ''), (!profileCenter ? 'pl-0' : ((showNavBar && showNav) ? 'pl-4' : 'pr-6'))]">
            <ng-container *ngIf="editTaxonomyTitle && title">
              <h1 id="titleTagEdit" class="h2 mb-0 d-inline-block text-truncate title-locked overflow-hidden page-title"
                [innerHtml]="title">
              </h1>
              <button class="btn btn-common edit d-inline-block ml-2 tooltip right" id="editTaxonomyBtn"
                [attr.aria-label]="'Edit '" data-tooltip="Edit" *ngIf="!preventEdit ? editTaxonomyTitle : false"
                data-toggle="modal" data-target="#editTaxonomy" (click)="selectEditIcon();"><span class="sr-only">Opens
                  in a new dialog</span>
                <em class="material-icons-outlined button-icon font-4x" aria-hidden="true">edit</em>
              </button>
            </ng-container>
            
            <h1 class="h2 mb-0 w-100 page-title" [ngClass]="{'pacing-guide-authoring-title position-relative': isAuthoringPage}"
              *ngIf="!editTaxonomyTitle">
              <span id="title_container" class="text-truncate d-inline-block title-locked overflow-hidden"
                [innerHtml]="titleHtml ? titleHtml : title">
              </span>

              <span class="dropdown project-authoring-dropdown position-relative"
                *ngIf="showMoreOption && !preventEdit">
                <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-reference="parent"
                  class="btn btn-icon tooltip px-1 py-0 d-inline right" id="editTaxoBtn" [attr.aria-label]="'Configure'"
                  data-tooltip="Configure">
                  <em class="material-icons-outlined font-4x mt-2">
                    <span aria-hidden="true">more_vert</span>
                    <span class="sr-only sr-only-focusable">more option</span>
                  </em>
                </button>

                <span class="dropdown-menu dropdown-menu-right">
                  <button *ngIf="preventReorder" id="reorderBtn" class="btn btn-clear dropdown-item"
                    (click)="onUpdateTaxonomyClick($event,'reorder')">Reorder</button>
                  <button (click)="onUpdateTaxonomyClick($event,'duplicate')" id="duplicateBtn" class="btn btn-clear dropdown-item">Copy</button>
                </span>
              </span>
              <button class="btn btn-clear edit d-inline-block position-relative tooltip right"
                id="gotoeditpageBtn" data-tooltip="Edit" [attr.aria-label]="'Edit ' + title"
                *ngIf="!preventEdit && showEditButton" (click)="goToEditPage()">
                <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
              </button>
            </h1>
          </div>
        </div>
      </div>
    </div>
      <app-tree-detail-search
                  class="search col-8"
                  *ngIf="searchTrigger && showSearchPanel"
                  [searchPlaceholder]="searchPlaceholder"
                  [viewLocation] = "viewLocation"
                  [hidden] = "currentTreeTab !=='listview'"
                  [enableAdvanceSearch]="enableAdvanceSearch"
                  (setSearchTriggerEvent)="setSearchTrigger($event)">
      </app-tree-detail-search>
    

    <div class="right-panel" [ngClass]="showBack?'col':'col-2'">
      <div class="w-100 d-flex justify-content-end align-items-center text-right">
        <div class="col-auto p-0" *ngIf="title==='Projects' && canRquestProjectAccess">
          <button class="btn btn-primary btn-sm" id="requestAccessmodalBtn" data-toggle="modal"
            data-target="#requestAccessModal" (click)="requestAccessModalClicked();">Request
            Access
          </button>
        </div>
        <div class="col-auto p-0" *ngIf="showProjectProgress">
          <app-project-status #projectStatus [preventEdit]="preventEdit" [showProjectStatus]="inProgressProject"
            [workFlowId]="workFlowId"></app-project-status>

        </div>
        <div class="col-auto p-0" *ngIf="!searchTrigger && showSearch" [attr.role]="showSearch?'search':null">
          <div class="col align-items-center search--node clearfix">
            <div class="search-icon p-0">
              <button type="button" class="btn btn-icon btn-common px-1 tooltip bottom font-4x position-relative" id="searchBtn" [attr.aria-label]="'Search'"
                data-tooltip="Search" (click)="searchTriggered();">
                <span class="material-icons-outlined button-icon" aria-hidden="true">search</span>
              </button>
            </div>
            <div class="search-field">
              <input type="text" [(ngModel)]="searchText" name="search" autocomplete="off" placeholder="Search.."
                id="searchtext" aria-label="Search" (keyup.enter)="onSearch()" (keyup)='updateSearchList()'
                tabindex="-1">
            </div>
          </div>
        </div>
        <div class="col-auto p-0" [hidden]="!showWorkflowStatus">
          <div class="dropdown float-right project--filter">
            <span class="font-bold">Workflow Status:</span>
            <div class="btn-group">
              <button aria-expanded="false" aria-haspopup="true"
                class="btn btn__filter btn-clear btn-sm dropdown-toggle font-bold" id="wrkfdropBtn"
                data-toggle="dropdown" id="exportTaxonomy" type="button" name="exportTaxonomy" [disabled]="preventEdit"
                aria-label="workflow status dropdown">
                {{ selectedFilterOption }}
              </button>

              <div aria-labelledby="exportTaxonomy" class="dropdown-menu dropdown-menu-right">
                <button aria-label="Export taxonomy as JSON" id="exptaxojsonBtn"
                  class="btn btn-clear btn-sm dropdown-item" (click)="filterData(obj)"
                  *ngFor="let obj of workFlowStages">{{obj.stage_name}}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Button for Review -->
        <div class="col-auto p-0" *ngIf="submitReview">

          <button class="btn btn-primary btn-sm mr-3" id="downloadReviewModalBtn" (click)="downloadReviewReport()"
            [disabled]="disableBtn">
            {{disableBtn ? 'Downloading...' : 'Download'}}
          </button>
          <button class="btn btn-primary btn-sm" data-toggle="modal" data-target="#submitReviewModal"
            *ngIf="showSubmitReview" id="submitreviewModalBtn" (click)="getCommentReport();">Submit Review<span
              class="sr-only">Opens in a
              new dialog</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
<div class="container-fluid px-0 custom-view" id="touchsurface"
  [ngClass]="[customView?'p-0':'',addContainerScroll?'overflow-auto':'']">

  <div class="container-fluid px-0"
    [ngClass]="{'col-12 pl-0':(!showNavBar || !showNav),'h-100':!isWorkflow, 'p-0':customView, '':!projectAuthoringView, 'pt-0': projectAuthoringView}">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center " [class.h-100]="!isWorkflow"
      [ngClass]="[showNav?'':'pt-0', (showPReviewHClass===true?'public_review':''), (showCViewHClass===true?'custom_view':'')]">
      <div class="container-fluid px-0 position-relative work-area" [ngClass]="customView?'pr-0':''">
        <main id="main_container" class="container-fluid main" [ngClass]="{'p-0':profileCenter}">
          <!-- end of project create section -->
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
  </div>

  <section *ngIf="showCSVStatus && !closeStatusWindow" class="csv_status_popup position-fixed border-bottom-0"
    id="myForm" role="dialog" aria-labelledby="csvTitle" aria-describedby="collapseCSV">
    <form class="form-container">

      <div class="d-flex w-100 py-1 justify-content-between align-item-center header">
        <div class="col-auto" id="headerTitle">
          <h2 class="font-3x header__title" id="csvTitle">Import Status</h2>
        </div>

        <div class="col-auto p-0 d-flex align-item-center">
          <div class="col-auto p-0">
            <button id="collapseToggle" type="button" class="btn btn-icon btn-sm btn-collapse position-relative p-3"
              data-toggle="collapse" data-target="#collapseCSV" aria-expanded="false" aria-controls="collapseCSV">
              <span class="sr-only">expand/collapse to view import status</span>
            </button>
          </div>
          <div class="col-auto p-0">
            <button id="btnClose" type="button" class="btn btn-icon btn-sm material-icons-outlined font-4x mt-1" (click)="close()" aria-label="close popup">
              <span aria-hidden="true">close</span>
            </button>
          </div>
        </div>
      </div>

      <app-status-popup-window #statusPopUp></app-status-popup-window>
    </form>
  </section>

  <div id="tickerContainer" [hidden]="!showTicker">
  </div>
  <lor-idle-check [config]="lorIdleCheckConfig" 
                  [startIdleCheck]="true" 
                  (userIsActive)="checkSessionCookie()"
                  (lorUserTimedOut) = "logoutUser()">
  </lor-idle-check>
</div>